export const VERSION_HISTORY_LABEL = 'View version history';
